// autogenerated by channel_search/generate.py -- do not edit
import { AutoRegionRequest } from "@skydio/pbtypes/pbtypes/gen/user_camera/auto_region_request_pb";
export { AutoRegionRequest };

export const CLIENT_AUTOFOCUS_REQUEST_PB = {
  channel: "CLIENT_AUTOFOCUS_REQUEST_PB",
  type: AutoRegionRequest.deserializeBinary
};
